import { ReactNode } from "react";

import { TabPanel } from "@/shared/ui/TabPanel";

type CustomTabPanelProps = {
	children?: ReactNode;
	index: number;
	value: number;
	fill?: boolean;
};

export function CustomTabPanel({
	children,
	index,
	value,
	fill,
}: CustomTabPanelProps) {
	return (
		<TabPanel
			currentTab={value}
			index={index}
			fill={fill}
			panelId={`simple-tabpanel-${index}`}
			labelledById={`simple-tab-${index}`}
		>
			{children}
		</TabPanel>
	);
}
